export enum ResourcesEndpointEnum {
  'GET_ROLE' = '/me',

  'GET_PORTAL_CONFIGURATION' = '/configuration/portalConfiguration',
  'PUT_PORTAL_CONFIGURATION' = '/configuration/portalConfiguration',

  'GET_GROUPS' = '/groups',
  'GET_GROUPSREPORTCONFIG' = '/reportConfig/groups',
  'GET_GROUP' = '/groups/:groupID',
  'POST_GROUP' = '/groups',
  'PUT_GROUP' = '/groups',
  'PUT_COLLAPSABLE_GROUP' = '/groups/:groupID/update',
  // 'GET_COLLAPSABLE_TITLES' = '/groups/collapsable-title',
  'POST_COLLAPSABLE_TITLE' = '/groups/collapsable-title',
  'PUT_COLLAPSABLE_TITLE_GROUPS' = '/groups/collapsable-title/:collapsableTitleID',
  'DEACTIVATE_GROUP' = '/groups/:groupID',
  'HARD_DELETE_GROUP' = '/groups/delete/purge/:groupID/:groupGUID',
  'ACTIVATE_GROUP' = '/groups',
  'UPLOAD_GROUP_LOGO' = '/groups/:groupID/logo/:fileName',//xx
  'UPLOAD_REPORT_IMAGE' = '/groups/:groupID/report/:reportID/icon/:fileName', //xx

  'GET_GROUP_REPORTS' = '/groups/:groupID/publishedReports',
  'GET_GROUP_REPORTS_DETAILS' = '/groups/:groupID/reports',

  'GET_USERS' = '/users',
  'GET_USER' = '/users/:userID',
  'PUT_OWNER' = '/groups/:securityGroupID/users/owner',
  'PUT_USER' = '/groups/:securityGroupID/users',//Invite User
  'POST_USER_BY_OWNER' = '/groups/:securityGroupID/users',//Add User by Owner

  'GIVE_USER_ACCESS' = '/groups/:securityGroupID/users', //Give User Access To Group
  'POST_USER' = '/groups/:securityGroupID/users',
  'REVOKE_USER_ACCESS' = '/groups/:groupID/RevokeAccessUser/:userID',
  'REVOKE_OWNER_ACCESS' = '/groups/:groupID/RevokeOwnerAccessUser/:userID',

  'DELETE_USER' = '/user/:userID',
  'GET_API_REPORT' = '/powerbi/:groupID/:reportType/:reportID',
  'POST_EXPORT_REPORT' = '/powerbi/:groupID/reports/:reportID/export',
  'GET_REPORT_EMBEDCONFIG_FOR_TESTING' = '/reports/testembedding/powerBI/group/:groupID/report/:reportID?RLSFilter=:RLSFilterText',
  'GET_REPORT' = '/groups/:groupID/report/:reportID',
  'GET_PINNED_FAVORITES_REPORTS' = '/reports/pinned-favorites',
  'GET_TITLES_BY_USER' = '/titles/user',
  'PUT_REPORT' = '/groups/:groupID/report/:reportID',
  'PUT_REPORT_FAVORITE' = '/report/:reportID/favorite',

  'GET_ADMIN_HELP_PAGES' = '/config/help-pages',
  'GET_HELP_PAGE' = '/help-pages/:helpPageID',
  'GET_HELP_PAGES' = '/help-pages',
  'PUT_HELP_PAGE' = '/config/help-pages/:helpPageID',
  'POST_HELP_PAGE' = '/config/help-pages',
  'DELETE_HELP_PAGE' = '/config/help-pages/:helpPageID',
  'UPLOAD_IMAGE' = '/blobUploader/help-pages-images/:fileName', //xx
  'UPLOAD_USER_LOGO' = '/users/:userID/logo/:fileName', //xx

  'UPLOAD_LOGO' = '/blobUploader/ConfigurationImage/:fileName', //xx
  'UPLOAD_SIGNIN_PAGE_LOGO' = '/configuration/signInPageLogo/:fileName', //xx
  'GET_API_VERSION' = '/configuration/apiVersion',
  'POST_UPDATE_USER_ACCESS' = '/users/updateAccess',
  'POST_UPDATE_PORTAL_PREMIUM_STATUS' = '/configuration/CheckPremiumStatus',

  'GET_TITLES' = '/groups/collapsable-title',//old endpoint in baseline nuget, but don't use it in this project because can reuse data from GET_CATEGORIES with exended
  'GET_COLLAPSABLE_TITLE' = '/groups/collapsable-title/:collapsableTitleID',
  'GET_COLLAPSABLE_WITH_REPORTS' = '/groups/collapsable-title/with-reports',
  'POST_EMBED_FAVORITE' = '/me/category/:collapsableTitleID/embed/:embedId/favorite',
  'GET_FAVORITES_REPORTS_EMBED' = '/me/reportsEmbeds/favorites',


  'POST_CATEGORY_TITLE' = '/groups/category/extended',
  'PUT_CATEGORY_TITLE_GROUPS' = '/groups/category/:collapsableTitleID/extended',
  'UPLOAD_CATEGORY_TITLE_LOGO' = '/groups/collapsable-title/:collapsableTitleID/logo/:fileName',//old endpoint, is not implemented in backend
  'UPLOAD_EMBED_CONFIG_IMAGE' = '/category/:collapsableTitleID/embed/:embedConfigId/image/:fileName',
}
